import MaterialStepper, { StepperProps } from '@mui/material/Stepper';

function Stepper(props: StepperProps) {
    return <MaterialStepper data-testid={'Stepper-container'} {...props} />;
}

export default Stepper;
